import { LoaderFunctionArgs, Outlet, useLocation } from "react-router";
import { getLocale } from "~/i18n";


export const loader = async ({ request }: LoaderFunctionArgs) => {
  // This will ensure that invalid locales do not render page
  const locale = getLocale(request.url);
  if (locale === null) {
    throw new Response(null, { status: 404 });
  }

  return null;
};

export default function Index() {
  const locale = getLocale(useLocation().pathname);

  return (
      <main className="w-full flex flex-col gap-6">
        <Outlet />
      </main>
  );
}
